import { GET_ADDVEHICLE_FAILED, GET_ADDVEHICLE_REQUESTED, GET_ADDVEHICLE_SUCCESS, GET_DELETEVEHICLE_FAILED, GET_DELETEVEHICLE_REQUESTED, GET_DELETEVEHICLE_SUCCESS, GET_UPDATEVEHICLE_FAILED, GET_UPDATEVEHICLE_REQUESTED, GET_UPDATEVEHICLE_SUCCESS, GET_VEHICLE_FAILED, GET_VEHICLE_REQUESTED, GET_VEHICLE_SUCCESS, GET_MATRIXVEHICLE_FAILED, GET_MATRIXVEHICLE_REQUESTED, GET_MATRIXVEHICLE_SUCCESS, GET_MOREVEHICLE_FAILED, GET_MOREVEHICLE_REQUESTED, GET_MOREVEHICLE_SUCCESS } from "resources/actionTypes";

const initialState = {
  userVehicle: [],
  loading: false,
  error: null,
};

const initialStateAdd = {
  userAddVehicle: [],
  loading: false,
  error: null,
}

const initialStateUpdate = {
  userUpdateVehicle: [],
  loading: false,
  error: null,
}

const initialStateDelete = {
  userDeleteVehicle: [],
  loading: false,
  error: null,
}

const initialStateMatrix = {
  userMatrixVehicle: [],
  loading: false,
  error: null,
}


const initialStateMore = {
  userMoreVehicle: [],
  loading: false,
  error: null,
}

export function userVehicle(state =
  initialState, action) {
  switch (action.type) {
    case GET_VEHICLE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_VEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        userVehicle: action.userVehicle
      };
    case GET_VEHICLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}


export function userAddVehicle(state = initialStateAdd, action) {
  switch (action.type) {
    case GET_ADDVEHICLE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDVEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        userAddVehicle: action.userAddVehicle,
      };
    case GET_ADDVEHICLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateVehicle(state = initialStateUpdate, action) {
  switch (action.type) {
    case GET_UPDATEVEHICLE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATEVEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateVehicle: action.userUpdateVehicle,
      };
    case GET_UPDATEVEHICLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userDeleteVehicle(state = initialStateDelete, action) {
  switch (action.type) {
    case GET_DELETEVEHICLE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_DELETEVEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        userDeleteVehicle: action.userDeleteVehicle,
      };
    case GET_DELETEVEHICLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userMatrixVehicle(state =
  initialStateMatrix, action) {
  switch (action.type) {
    case GET_MATRIXVEHICLE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_MATRIXVEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        userMatrixVehicle: action.userMatrixVehicle
      };
    case GET_MATRIXVEHICLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userMoreVehicle(state =
  initialStateMore, action) {
  switch (action.type) {
    case GET_MOREVEHICLE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_MOREVEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        userMoreVehicle: action.userMoreVehicle
      };
    case GET_MOREVEHICLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
